import { render, staticRenderFns } from "./conta.vue?vue&type=template&id=5006d502&"
import script from "./conta.vue?vue&type=script&lang=js&"
export * from "./conta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports